"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedMechanism = exports.BoxType = exports.Environment = exports.CodeLength = void 0;
exports.parseV1Code = parseV1Code;
const Index_1 = require("../Index");
// Code length
// Access code can either be 8 digits or 16 digits
var CodeLength;
(function (CodeLength) {
    CodeLength[CodeLength["EIGHT"] = 0] = "EIGHT";
    CodeLength[CodeLength["SIXTEEN"] = 1] = "SIXTEEN";
})(CodeLength || (exports.CodeLength = CodeLength = {}));
// Environment
// If the enviroment is dev/test, then the box URL is determined from a config
// file in the apk. If it is prod, then additional information is processed
// to generate the app URL.
var Environment;
(function (Environment) {
    Environment[Environment["DEV_TEST"] = 0] = "DEV_TEST";
    Environment[Environment["PROD"] = 1] = "PROD";
})(Environment || (exports.Environment = Environment = {}));
// Box type
// If box type is physical, then the box IP address is fixed. Else if it is
// virtual, the embed mechanism is used to determine the URL.
var BoxType;
(function (BoxType) {
    BoxType[BoxType["PHYSICAL"] = 0] = "PHYSICAL";
    BoxType[BoxType["VIRTUAL"] = 1] = "VIRTUAL";
})(BoxType || (exports.BoxType = BoxType = {}));
// Embed Mechanism
// If the embed mechanism is direct map, then a six bit-index is used to look
// into a table that will be shipped with the app. If it is generated, then it
// an additional 3-bit template and 6-bit ID is used to
var EmbedMechanism;
(function (EmbedMechanism) {
    EmbedMechanism[EmbedMechanism["DIRECT_MAP"] = 0] = "DIRECT_MAP";
    EmbedMechanism[EmbedMechanism["GENERATED"] = 1] = "GENERATED";
})(EmbedMechanism || (exports.EmbedMechanism = EmbedMechanism = {}));
/**
 * Parse a V1 access code and return the relevant access code information
 */
function parseV1Code(accessCode, config) {
    // If V1 config is not present, throw an error
    if (!config)
        throw new Error('Cannot parse V1 access code. Config not present');
    // Convert access code to integer
    const accessCodeInt = Number.parseInt(accessCode);
    if (isNaN(accessCodeInt))
        throw new Error('Access code is not an integer');
    const length = accessCode.length == 8 ? CodeLength.EIGHT : accessCode.length == 16 ? CodeLength.SIXTEEN : undefined;
    if (length == undefined)
        throw new Error('Invalid access code length');
    const binaryLength = length == CodeLength.EIGHT ? 26 : 53;
    const accessCodeBinaryString = accessCodeInt.toString(2).padStart(binaryLength, '0');
    const header = Number.parseInt(accessCodeBinaryString.slice(-6), 2);
    const version = header & 3;
    const lengthInfo = (header >> 2) & 1;
    const boxType = (header >> 3) & 1;
    const env = (header >> 4) & 1;
    const mechanism = (header >> 5) & 1;
    // Perform basic checks
    if (version != Index_1.AccessCodeVersion.V1)
        throw new Error('Invalid access code version');
    if (length != lengthInfo)
        throw new Error('Invalid access code length');
    // Basic object
    const response = {
        version: Index_1.AccessCodeVersion.V1,
        length: accessCode.length,
        physical_box: boxType == BoxType.PHYSICAL,
        env: env == Environment.DEV_TEST ? 'test' : 'production',
    };
    // If box type is physical or environment is dev/test, there is no information
    // to be extracted
    if (boxType == BoxType.PHYSICAL || env == Environment.DEV_TEST)
        return response;
    // Check the mechanism
    const { directs, templates } = config;
    if (mechanism == EmbedMechanism.DIRECT_MAP) {
        const index = Number.parseInt(accessCodeBinaryString.slice(-12, -6), 2);
        const box_url = directs[index];
        return Object.assign(Object.assign({}, response), { box_url });
    }
    else {
        const templateId = Number.parseInt(accessCodeBinaryString.slice(-12, -6), 2);
        const templateIndex = Number.parseInt(accessCodeBinaryString.slice(-15, -12), 2);
        const box_url = templates[templateIndex].replace('#', templateId.toString());
        return Object.assign(Object.assign({}, response), { box_url });
    }
}
//# sourceMappingURL=V1.js.map